// extracted by mini-css-extract-plugin
export default {"labelColorIndicator":"ListLabelFilter-module__labelColorIndicator--fdoSZ","labelFilterButton":"ListLabelFilter-module__labelFilterButton--zPHv9"};